import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  // 列表查询
  selectVersionHistoryList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/selectVersionHistoryList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 基础分修改详情
  detailsSu({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/selectVersionHistoryRecord`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 参考分修改详情
  detailsRe({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/selectVersionHistoryRecord`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 修改详情
  moreDetailsSu({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseScore/selectVersionHistoryRecordMore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 修改详情
  moreDetailsRe({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/selectVersionHistoryRecordMore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 同步数据校验
  checkSyncRepetitionData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/checkSyncRepetitionData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 同步数据
  syncData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/syncData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delRecord({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/delRecord`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}

